import { errorMessage } from "helpers/utils";
import { call, put, takeEvery } from "redux-saga/effects";
import reportManagementService from "services/reportManagementService";
import {
  downloadReportFail,
  downloadReportSuccess,
  exportReportFail,
  exportReportSuccess,
  listReportFail,
  listReportSuccess,
} from "./actions";
import { REPORT_DOWNLOAD, REPORT_EXPORT, REPORT_LIST } from "./actionTypes";

function* fetchListReport({ payload }) {
  try {
    const response = yield call(reportManagementService.listReport, payload);
    yield put(listReportSuccess(response));
  } catch (error) {
    yield put(listReportFail(errorMessage(error)));
  }
}

function* onExportReport({ payload }) {
  try {
    const response = yield call(reportManagementService.exportReport, payload);
    yield put(exportReportSuccess(response));
  } catch (error) {
    yield put(exportReportFail(errorMessage(error)));
  }
}

function* onDownloadReport({ payload }) {
  try {
    const response = yield call(
      reportManagementService.downloadReport,
      payload
    );

    yield put(
      downloadReportSuccess({
        fileName: payload.fileName,
        file: response,
        fileUrl: URL.createObjectURL(response),
      })
    );
  } catch (error) {
    yield put(downloadReportFail(errorMessage(error)));
  }
}

function* reportManagementSaga() {
  yield takeEvery(REPORT_LIST, fetchListReport);
  yield takeEvery(REPORT_EXPORT, onExportReport);
  yield takeEvery(REPORT_DOWNLOAD, onDownloadReport);
}

export default reportManagementSaga;
